$(document).on("click", ".footer__sticky-collection", function (e) { e.preventDefault(), $(this).parents("body").find('.header__icon-wrapper[aria-controls="mobile-menu-drawer"]').click() }), $(document).on("click", ".product-meta .jm-badge", function () { $("html,body").animate({ scrollTop: $("#judgeme_product_reviews").offset().top - 150 }, "fast") }), $(document).on("click", ".active-offers-container .copy_code", function () { var e = $("<input>"); $("body").append(e), e.val($(this).prev().text()).select(), document.execCommand("copy"), e.remove(); let t = $(this).find(".tooltiptext"); t.css("visibility", "visible"), setTimeout(function () { t.css("visibility", "hidden") }, 1e3) }), $(document).on("click", "#read_more_desc", function () { screen.width <= 740 ? $("#product-desc-trust-popover").attr("open", "open") : $("#product-desc-trust-drawer").attr("open", "open") }), $(document).on("click", "#view_all_ingredients", function () { screen.width <= 740 ? $("#product-ingredients-trust-popover").attr("open", "open") : $("#product-ingredients-trust-drawer").attr("open", "open") }), $(document).on("click", "#read_more_faqs", function () { screen.width <= 740 ? $("#product-faqs-trust-popover").attr("open", "open") : $("#product-faqs-trust-drawer").attr("open", "open") }), $(document).on("click", ".product-sticky-form__payment-container .custom_qty_btn", function () { setTimeout(function () { let e = $(".custom_qty").val(); $(".product-form").find(".quantity-selector__input").val(e) }, 300) }); const tabs_nav = document.querySelectorAll(".tab-nav-container:not(.product-tab-nav) .tabs-nav__item"); tabs_nav.forEach(e => { e.addEventListener("click", function (t) { t.preventDefault(); let r = e.closest(".tab-nav-container").classList; r = String(r).trim().replaceAll(" ", "."), document.querySelectorAll("." + r + " .tabs-nav__item").forEach(e => { e.classList.remove("active") }), this.classList.add("active"); let o = this.getAttribute("href"); scroll({ top: document.querySelector(o).offsetTop - 150, behavior: "smooth" }) }) }); const links = document.querySelectorAll(".product-tab-nav.tab-nav-container .tabs-nav__item"); function navHighlighter() { let e = window.pageYOffset, t = document.querySelector("store-header")?.getBoundingClientRect().height; if ("load" == event.type) { let r = window.location.hash; if (r) { let o = document.querySelector(r)?.offsetTop - (57 + (t || 85)); o && scroll({ top: o }) } document.querySelector(".tab-nav-container")?.closest(".shopify-section").setAttribute("style", `top: ${t}px`) } links.length && links.forEach(r => { r.onclick = function (e) { let r = this.getAttribute("data-href"); scroll({ top: document.querySelector(r).offsetTop - (57 + (t || 85)), behavior: "smooth" }) }; let o = document.querySelector(r.getAttribute("data-href")), s = o?.offsetHeight, n = o?.offsetTop - (59 + (t || 85)), a = r.getAttribute("data-href"); e >= n && e <= n + s ? document.querySelector(`a[data-href="${a}"]`).classList.add("active") : document.querySelector(`a[data-href="${a}"]`).classList.remove("active") }) } window.addEventListener("scroll", navHighlighter), window.addEventListener("load", navHighlighter), window.addEventListener("resize", navHighlighter); var i, acc = document.getElementsByClassName("accordion"); for (i = 0; i < acc.length; i++)acc[i].addEventListener("click", function () { this.classList.toggle("active"); var e = this.nextElementSibling; e.style.maxHeight ? (e.style.maxHeight = null, this.innerHTML = this.innerHTML.replace("&#9660;", "&#9650;")) : (e.style.maxHeight = e.scrollHeight + "10px", this.innerHTML = this.innerHTML.replace("&#9650;", "&#9660;")) }); function enableSwiperMode(){document.querySelectorAll(".swipeable_slideshow").forEach(e=>{let t=e.querySelectorAll("slide-show-item");if(t.length>1){let o=e.querySelectorAll("page-dots > button"),s=e.querySelector(".slideshow__slide-list"),l=t[1].offsetLeft-t[0].offsetLeft;function n(e,t,n){if(!s)return;if(n>t){let c=e.target.closest("slide-show-item")?.previousElementSibling;if(!c)return;let i=c.offsetLeft;s.scrollTo(i,0),o[Math.round(i/l)]?.click()}else{let r=e.target.closest("slide-show-item")?.nextElementSibling;if(!r)return;let d=r.offsetLeft;s.scrollTo(d,0),o[Math.round(d/l)]?.click()}}e.querySelector("page-dots")?.addEventListener("page-dots:changed",function(e){let o=t[e.detail.index].offsetLeft;s.scrollTo(o,0)});if(screen.width>=600){let a;s?.addEventListener("dragstart",e=>{a=e.pageX}),s?.addEventListener("dragend",e=>{let t=e.pageX;n(e,a,t)})}else{let u;s?.addEventListener("touchstart",e=>{u=e.touches[0].clientX}),s?.addEventListener("touchend",e=>{let t=e.changedTouches[0].clientX;n(e,u,t)})}}})} if ($("#shopify-section--play-and-win .logo-list__item").on("click", function () { let e = $(this).find(".logo-list__item-link").text(); e ? ($("#game-launcher-popup").append('<iframe width="100%" height="75%" src="' + e + '"></iframe>'), $("#game-launcher-popup").addClass("visible"), $("html").css("overflow-y", "hidden"), $("main#MainContent").addClass("custom-modal-opacity")) : $(".close-game-popup").trigger("click") }), $(".close-game-popup").on("click", function () { $("#game-launcher-popup").removeClass("visible"), $("html").css("overflow-y", "unset"), $("main#MainContent").removeClass("custom-modal-opacity"), $("#game-launcher-popup iframe").remove() }), $(".surprise__button").on("click", function (e) { e.preventDefault(), $(this).parents(".surprise-for-you-popdraw").find("header button").trigger("click"), $("#surprise-for-you-popup").addClass("visible"), $("html").css("overflow-y", "hidden"), $("main#MainContent").addClass("custom-modal-opacity") }), $(".close-surprise-popup").on("click", function () { $("#surprise-for-you-popup").removeClass("visible"), $("html").css("overflow-y", "unset"), $("main#MainContent").removeClass("custom-modal-opacity") }), $(".newsletter-modal__form").on("submit", function (e) { let t = { tags: $('[name="contact[tags]"]').val(), email: $('[name="contact[email]"]').val(), phone: $('[name="contact[note][phone]"]').val() }; $.ajax({ type: "POST", url: "https://webengagebackup.discoverpilgrim.com/polls/update_newsletter_customer", data: JSON.stringify(t), dataType: "json", success: function (e) { alert("Newsletter subscribed!"), console.log(e) }, error: function (e) { alert("Something went wrong. Please try again later!") } }) }), $(document).on("click", ".swatch-wrapper", function () { $(this).parent().next(".product-item__cta-wrapper").find("button.product-item__cta").trigger("click") }), $(document).on("click", ".corporate_gifting_kits .gallery__figure img", function () { let e = $(this).parents("#main").find("section.corporate_gifting_callback_form"); $("html,body").animate({ scrollTop: e.offset().top - 100 }, "fast") }), $(document).on("click", "quick-buy-drawer .product-form .product-form__add-button", function () { $("quick-buy-drawer").find(".drawer__close-button").trigger("click"), $('.header__icon-wrapper[aria-controls="mini-cart"]').attr("aria-expanded", "true") }), $(".product-form .custom_qty_btn").on("click", function () { let e = $(this).parent(".quantity-selector").find(".quantity-selector__input.custom_qty"); setTimeout(function () { $(".product-form").find(".quantity-selector__input").val(e.val()), $(".product-sticky-form__payment-container").find(".quantity-selector__input").val(e.val()) }, 300) }), $(document).on("click", ".banner_newsletter", function () { $('button[aria-controls="newsletter-popup"]').trigger("click") }), !function (e, t) { "function" == typeof t && (e.fetch = function () { let e = t.apply(this, arguments); return e.then(e => { [`${window.location.origin}/cart/change.js`, `${window.location.origin}/cart/add.js`].includes(e.url) && e.clone().json().then(e => { 422 == e.status && ($("cart-notification[global]").find("span.cart-notification__heading").text(e.message), $("cart-drawer .cart-notification").removeAttr("hidden"), $("cart-drawer .cart-notification").css("display", "block"), $("cart-drawer .cart-notification").find("span.cart-notification__heading").text(e.message), cn = document.querySelector('.cart-notification-error'), cn && (cn.style.display = 'flex', cn.querySelector('.cart-notification-error-text').textContent = e.message, setTimeout(() => { cn.style.display = 'none' }, 3000))) }) }), e }) }(window, window.fetch), enableSwiperMode(), document.addEventListener("htmlRendered", () => { console.log("htmlRendered"), enableSwiperMode() }), document.querySelector(".product_variantfilter")) { let e = document.querySelectorAll(".product_filters > li > a"); function t(t, r) { let o = t.dataset.variantNames.split("|").filter(Boolean), s = (t.closest(".product-form__option-selector") || t.closest(".product_filters").parentElement).querySelectorAll(".variants_wrapper .color-swatch-list > div > input, .variants_wrapper .variant-swatch-list > div > input, .variants_wrapper .block-swatch-list > div > input"); s.forEach(e => e.parentElement.classList.add("hide")), o.forEach(e => { e.split("/").forEach(e => { s.forEach(t => { t.dataset.optionValue.trim() == e.trim() && t.parentElement.classList.remove("hide") }) }) }), e.forEach(e => e.classList.remove("active")), t.classList.add("active"); let n = (t.closest(".product-form__option-selector") || t.closest(".product_filters").nextElementSibling).querySelectorAll(".variants_wrapper .color-swatch-list > div:not(.hide) > label, .variants_wrapper .variant-swatch-list > div:not(.hide) > label"); !r && n.length && n[0].click() } function r(r) { "All" === r.dataset.variantNames ? ((r.closest(".product-form__option-selector") || r.closest(".product_filters").parentElement).querySelectorAll(".variants_wrapper .color-swatch-list > div > input, .variants_wrapper .variant-swatch-list > div > input, .variants_wrapper .block-swatch-list > div > input").forEach(e => e.parentElement.classList.remove("hide")), e.forEach(e => e.classList.remove("active")), r.classList.add("active")) : t(r) } e.forEach(e => { e.addEventListener("click", () => r(e)), e.classList.contains("active") && "All" !== e.dataset.variantNames && t(e, !0) }), new MutationObserver(o => { o.forEach(o => { Array.from(o.addedNodes).filter(e => e instanceof Element).forEach(o => { let s = o; (s.classList.contains("variants_wrapper") || s.querySelector(".variants_wrapper")) && (s.addEventListener("variants_wrapper", () => { (e = document.querySelectorAll(".product_filters > li > a")).forEach(e => { e.addEventListener("click", () => r(e)), e.classList.contains("active") && "All" !== e.dataset.variantNames && t(e, !0) }) }), s.dispatchEvent(new Event("variants_wrapper"))) }) }) }).observe(document.body, { childList: !0, subtree: !0 }) } function sendPixel(e, t) { var r, o; let s = [], n; r = e, o = t, (n = JSON.parse(sessionStorage.getItem("testGroups")))?.length > 0 && n.forEach(e => { e[r] = o, e.page_url = sessionStorage.getItem("page_url"), s.push(e) }), s.length > 0 && s.forEach(e => { fetch("https://ablivestestfirestore-92bec3ro.uc.gateway.dev/?key=AIzaSyC99sFl4r7RuFHOClJZHrTFzdSU1IPUzKs", { method: "POST", body: JSON.stringify({ name: { clientId: "xyg", allPayload: [e], timestamp: String(new Date) } }), headers: { "Content-Type": "application/json" } }).then(e => e.text()).then(e => console.log(e, "Theme result")).catch(e => console.warn(e, "fetch error pixel")) }) } document.addEventListener("click", function (e) { if (e.target.classList.contains("copy-btn")) { let t = document.getElementById("copy-notification"); t.classList.add("show"), t.classList.remove("hide"), setTimeout(function () { t.classList.add("hide"), t.classList.remove("show") }, 2e3); let r = e.target.closest(".offer_banner").querySelector(".copy-text").innerHTML, o = document.createElement("textarea"); o.value = r, document.body.appendChild(o), o.select(), document.execCommand("copy"), document.body.removeChild(o) } }), document.addEventListener("click", e => { (e.target.classList.contains("pswp__button--close") || e.target.closest("product-image-zoom")) && setTimeout(() => {/*e.target.closest("product-image-zoom").classList.remove("pswp--open")*/ }, 500) }); function addTocartDisabled() { document.querySelector('[id="AddToCart"]').classList.add("button--ternary"), document.querySelector('[id="AddToCart"]').classList.remove("button--primary"), document.querySelector('[id="AddToCart"]').setAttribute("disabled", "true"), document.querySelector('[id="AddToCart"] .loader-button__text').innerHTML = "⌛ Coming Soon", document.querySelector('[id="StickyAddToCart"]').classList.add("button--ternary"), document.querySelector('[id="StickyAddToCart"]').classList.remove("button--primary"), document.querySelector('[id="StickyAddToCart"]').setAttribute("disabled", "true"), document.querySelector('[id="StickyAddToCart"] .loader-button__text').innerHTML = "⌛ Coming Soon" } function addTocartEnable() { document.querySelector('[id="AddToCart"]').classList.remove("button--ternary"), document.querySelector('[id="AddToCart"]').classList.add("button--primary"), document.querySelector('[id="AddToCart"]').removeAttribute("disabled"), document.querySelector('[id="AddToCart"] .loader-button__text').innerHTML = "Add to cart", document.querySelector('[id="StickyAddToCart"]').classList.remove("button--ternary"), document.querySelector('[id="StickyAddToCart"]').classList.add("button--primary"), document.querySelector('[id="StickyAddToCart"]').removeAttribute("disabled"), document.querySelector('[id="StickyAddToCart"] .loader-button__text').innerHTML = "Add to cart" } function showLable() { let e = document.querySelector("product-sticky-form"); e && window.scrollY > 30 && setTimeout(() => { e.querySelector(".people-bought")?.classList.add("show") }, 500) } document.addEventListener("DOMContentLoaded", e => { document.querySelector(".custom_option.is-disabled input:checked") && addTocartDisabled() }), document.addEventListener("change", function (e) { if (e.target.closest(".combo-variant-selector")) { e.target?.dataset?.title && (e.target.closest(".variant").querySelector(".selected_option").innerHTML = e.target.dataset.title), e.target.closest(".is-disabled") ? addTocartDisabled() : addTocartEnable(); let t = document.querySelectorAll(".combo-variant-selector input:checked"), r = document.querySelector('[name="properties[_all_product]"]'), o = document.querySelector('[name="properties[products]"]'), s = [], n = []; t.forEach(e => { s.push(e.value), n.push(e.dataset.title) }), s.length > 0 && (r.value = s.join(), o.value = n.join("/")) } }), showLable(), document.addEventListener("scroll", e => { showLable() }), $(document).on("click", "#upvoteSlideButton", function () { document.getElementById("newsletter-upvote-popup").open = !0 }), $(document).on("click", '.newsletter-upvote-modal__form button[type="submit"]', function (e) { let t = $(".newsletter-upvote-modal__form").find('[name="contact[tags]"]').val(), r = $(".newsletter-upvote-modal__form").find('[name="contact[email]"]').val(), o = $(".newsletter-upvote-modal__form").find('[name="contact[note][phone]"]').val(); sessionStorage.setItem("upvote-popup", "true"), r && o ? $.ajax({ type: "POST", url: "https://webengagebackup.discoverpilgrim.com/polls/update_newsletter_customer", data: JSON.stringify({ tags: t, email: r, phone: o }), dataType: "json", success: function (e) { }, error: function (e) { 0 != e.status && alert("Something went wrong. Please try again later!") } }) : (e.preventDefault(), "" === r ? $(".newsletter-upvote-modal__form").find('[name="contact[email]"]').addClass("invalid") : "" === o && $(".newsletter-upvote-modal__form").find('[name="contact[note][phone]"]').addClass("invalid")) }), document.addEventListener("DOMContentLoaded", e => { sessionStorage.getItem("facetToolbarClicked") || sessionStorage.setItem("facetToolbarClicked", "false"); let t = window.location.href; t.includes("gpay-b1g1-2l") ? document.getElementById("mobile-facet-toolbar").addEventListener("click", function () { "true" != sessionStorage.getItem("facetToolbarClicked") ? fetch("https://script.google.com/macros/s/AKfycbwBJx0z0a4JwXwYGLCSyU-Ltx41j6fxK8GU6ZNQ5kC7XHbG9fyVlAmpCJbkqSH4sAVh/exec", { method: "POST", mode: "no-cors", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ url: t }) }).then(e => { sessionStorage.setItem("facetToolbarClicked", "true") }).catch(e => { console.warn("Error sending click data:", e) }) : console.log("Facet toolbar click already tracked in this session.") }) : console.log("URL does not contain gpay-b1g1-2l") }); const upvoteButtonsCard = document.querySelectorAll(".upvote-product-card"); function updateVotes(){let t=Math.floor(Date.now()/1e4-172424e3)%400+400,e=document.querySelectorAll(".upvote-product-card-vote");if(e.length>0){let o=[0,12,23,37,49,63,78,92,107,123,141,159];e.forEach((e,_)=>{_<o.length&&(e.textContent=Math.floor(parseInt(e.textContent||100)+t-o[_])+" votes")})}}upvoteButtonsCard.length > 3 && (upvoteButtonsCard[0].innerHTML += '<img class="badge_image" src="https://cdn.shopify.com/s/files/1/0620/1629/1045/files/Gold_badge_1.png?v=1724094293">', upvoteButtonsCard[1].innerHTML += '<img class="badge_image" src="https://cdn.shopify.com/s/files/1/0620/1629/1045/files/Silver_badge_2.png?v=1724094294">', upvoteButtonsCard[2].innerHTML += '<img class="badge_image" src="https://cdn.shopify.com/s/files/1/0620/1629/1045/files/Bronze_badge_3.png?v=1724094294">'), updateVotes(), document.addEventListener("DOMContentLoaded", function () { document.querySelectorAll(".upvote-vote-button").forEach(e => { e.addEventListener("click", function () { let e = this.closest(".upvote-product-card"), t = e.querySelector(".upvote-product-card-title").textContent, r = e.querySelector(".upvote-product-card-vote").textContent, o = e.querySelector(".upvote-vote-button").dataset.productnumber; r.textContent = parseInt(r) + 1 + " votes"; let s = parseInt(r) + 1, n = sessionStorage.getItem("upvoted_sucessfully"); "true" !== n && (sessionStorage.setItem("upvoted-product-name", t), sessionStorage.setItem("upvoted-product-vote", s), sessionStorage.setItem("upvoted-product-index", o)), "true" === n && (document.querySelector(".upvoteSlide_vote_count").textContent = "") }) }) }); const submitedVoteFlag = sessionStorage.getItem("upvote-popup"), upvoted_sucessfully = sessionStorage.getItem("upvoted_sucessfully"); function updatemessage() { let e = document.querySelector("#bord_message .user_message"), t = document.querySelector("#bord_message .user_name"), r = document.getElementById("user-message").value.trim(), o = document.getElementById("user-name").value.trim(); (e.textContent = r) ? t.textContent = o || "Your name..." : (t.textContent = o || "", e.textContent = r || "Your message..."), e.textContent = r || "Your message..." } "true" === submitedVoteFlag && document.querySelectorAll(".upvote-vote-button").forEach(e => { document.getElementById("upvote_form_content") && ((document.getElementById("upvote_form_content").style.display = "none"), document.querySelector('.thanks-hide').style.display = 'none', document.querySelector('.thanks-txt').style.display = 'block'), document.getElementById("upvote_sucess_content") && (document.getElementById("upvote_sucess_content").style.display = "block"); let t = sessionStorage.getItem("upvoted-product-name"); document.querySelector(".upvoteSlide_vote_text_title").textContent = t, document.querySelector(".upvoteSlide_vote_text_title_share").textContent = t; let r = sessionStorage.getItem("upvoted-product-index"), o = document.querySelectorAll(".upvote-vote-button"); o.forEach((item, index) => { index != (r - 1) ? item.style.display = 'none' : null; }); o[r - 1].innerHTML = '<span class="pvoteSlideButton_text"> Voted!</span>', o[r - 1].classList.add('voted'), o[r - 1].style.backgroundColor = "rgb(56 142 60 / 50%)"; if (e.dataset.productnumber == r) { let upShare = document.createElement('span'); upShare.classList.add('upvote-share'); let innerSpan = document.createElement('span'); upShare.append(innerSpan); o[r - 1].after(upShare); } }), document.addEventListener("DOMContentLoaded", function () { let e = document.getElementById("board"), t = document.querySelector("#board"), r = window.pageYOffset, o = new IntersectionObserver(e => { e.forEach(e => { e.isIntersecting ? window.addEventListener("scroll", s) : window.removeEventListener("scroll", s) }) }, { threshold: .5 }); function s() { let t = window.pageYOffset; t > r ? (n(e, e.scrollTop + 1), setTimeout(() => { n(e, e.scrollTop + 1) }, 350)) : (n(e, e.scrollTop - 1), setTimeout(() => { n(e, e.scrollTop - 1) }, 350)), r = t } function n(e, t) { e.style.transition = "scroll-top 1s ease-out", e.scrollTop = t } t && o.observe(t) }), document.getElementById("board") && document.addEventListener("DOMContentLoaded", function () {
    let e = "https://script.google.com/macros/s/AKfycbz-NAbJYdPQMonWIF-plprSvd4YpDCZ5AMthT1unPM6cAr8qbbYi8Pwvo4izer50nOh/exec", t = ["https://cdn.shopify.com/s/files/1/0620/1629/1045/files/confetti-ball_1f38a.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/partying-face_1f973.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/birthday-cake_1f382.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/mirror-ball_1faa9.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/wrapped-gift_1f381_1.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/confetti-ball_1f38a.gif?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/wrapped-gift_1f381.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/balloon_1f388.gif?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/clinking-glasses_1f942.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/bottle-with-popping-cork_1f37e.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/shortcake_1f370.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/party-popper_1f389.png?v=1724229685", "https://cdn.shopify.com/s/files/1/0620/1629/1045/files/mirror-ball_1faa9_1.png?v=1724241584",]; (function e(t) { let r = t.length; for (; 0 != r;) { let o = Math.floor(Math.random() * r); r--, [t[r], t[o]] = [t[o], t[r]] } })(t), fetch(e).then(e => e.json()).then(e => {
        e.forEach((e, r) => {
            !0 === e.show && (document.getElementById("board").innerHTML += `
                <div class="sticky-container" id="sticky-${r}">
                    <div class="sticky-content" >
                    <div class="sticky-content_container" style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    gap: 10px;
                    align-content: flex-start;
                    ">
                    <img class="sticky_emoji" src="${t[r]}" />
                    <div class="sticky-content_container_message_box">
                    <p class="sticky-message" style="margin-bottom: 2px;">
                    ${e.message}
                    </p>
                    <p class="sticky-message" style="font-weight: 700;margin-top: 0 !important;">
                    - ${e.name}
                    </p>
                </div>
                </div>
                    </div>
                </div>`)
        })
    }).catch(e => {
        console.log("Error loading messages:", e), [{ name: "Kishan", message: "Happy birthday Pilgrim, love your products! \uD83C\uDF82\uD83C\uDF7E", show: !0 }, { name: "Sai", message: "Happiest birthday pilgrim\uD83D\uDC95", show: !0 }, { name: "Yash", message: "Happy birthday Pilgrim, love your products! \uD83C\uDC00\uDB82\uDC3C\uDB7E\uDC22", show: !0 }, { name: "Saloni", message: "Wishing you a successful year ahead, may you be graced with good work and goals\uD83C\uDF81", show: !0 }, { name: "Deepak", message: "Happy birthday \uD83E\uDD73 May your birthday usher in a year of good fortune", show: !0 }, { name: "Shashank", message: "Happy birthday pilgrim", show: !0 },].forEach((e, r) => {
            t[Math.floor(Math.random() * t.length)], null == !document.getElementById("board") && (document.getElementById("board").innerHTML += `
                <div class="sticky-container" id="sticky-${r}">
                    <div class="sticky-content" >
                    <div class="sticky-content_container" style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    gap: 10px;
                    align-content: flex-start;
                    ">
                    <img class="sticky_emoji" src="${t[r]}" />
                    <div class="sticky-content_container_message_box">
                    <p class="sticky-message" style="margin-bottom: 2px;">
                    ${e.message}
                    </p>
                    <p class="sticky-message" style="font-weight: 700;margin-top: 0 !important;">
                    - ${e.name}
                    </p>
                </div>
                </div>
                    </div>
                </div>`)
        })
    }), null == !document.getElementById("message-form") && document.getElementById("message-form").addEventListener("submit", function (t) {
        t.preventDefault(); let r = document.getElementById("user-name").value, o = document.getElementById("user-message").value; if (r && o) {
            let s = { name: r, message: o }; fetch(e, { method: "POST", mode: "no-cors", headers: { "Content-Type": "application/json" }, body: JSON.stringify(s) }).then(e => e).then(e => {
                var t; let r, o, n; t = s, r = document.getElementById("bord_message"), o = document.getElementById("message-form"), r.innerHTML = "", o.innerHTML = ` <div class="user-message-container"><div class="user-message-sucess">Thanks for the birthday wishes!</div>
    <img src="https://cdn.shopify.com/s/files/1/0620/1629/1045/files/tick_cross.svg?v=1722927062" alt="Happy Birthday" style="width: 20px;"/></div>`, r.removeAttribute("id"), r.remove, n = `<div class="sticky-container" id="sticky-8">
                    <div class="sticky-content" >
                    <div class="sticky-content_container" style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    gap: 10px;
                    align-content: flex-start;
                    ">
                    <img class="sticky_emoji" src="https://cdn.shopify.com/s/files/1/0620/1629/1045/files/birthday-cake_1f382.gif?v=1724229687" />
                    <div class="sticky-content_container_message_box">
                    <p class="sticky-message" style="margin-bottom: 2px;">
                    ${t.message}
                    </p>
                    <p class="sticky-message" style="font-weight: 700;margin-top: 0 !important;">
                    - ${t.name}
                    </p>
                </div>
                </div>
                    </div>
                </div>`, document.getElementById("board").insertAdjacentHTML("beforeend", n), document.getElementById("user-name").value = "", document.getElementById("user-message").value = "", s.show = !0
            }).catch(e => { console.warn("Error submitting message:", e) })
        }
    })
}); const check_QuickFilterStaticMain_Section = document.querySelector(".quick-filters-static_main"); if (null != check_QuickFilterStaticMain_Section?.firstElementChild) { function o() { setTimeout(() => { window.scrollTo({ top: 395, behavior: "auto" }) }, 100) } function s() { document.querySelector(".mobile-toolbar__item--sort").click() } function n() { document.querySelector(".mobile-toolbar__item--filters").click() } function a(e) { fetch("https://script.google.com/macros/s/AKfycbwKcm4BUDWMfVYD8WFZoyngsKa65uLoHrtxebu39gEQDDkC8TyC637WkaJ-k79LAjiEgg/exec", { method: "POST", headers: { "Content-Type": "application/json" }, mode: "no-cors", body: JSON.stringify(e) }).then(e => e.json()).then(e => console.log("Success:", e)).catch(e => console.warn("Error:", e)) } document.addEventListener("DOMContentLoaded", e => { let t = !1, r = null; function s() { let e = document.createElement("p"); e.textContent = "All", e.dataset.value = "All", e.classList.add("all-filters-categories", "selected-category"), e.addEventListener("click", () => { document.querySelectorAll("p.selected-category").forEach(e => { e.classList.remove("selected-category") }), e.classList.add("selected-category"), document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l1_category"] input[type=checkbox]:checked').forEach(e => e.click()), window.location.href = "https://discoverpilgrim.com/collections/gpay-b1g1-2l" }), document.querySelector(".collection-products.level_one_filters").insertBefore(e, document.querySelector(".collection-products.level_one_filters").firstChild) } s(); let n = []; function a() { console.log("3", "checkbox"), document.documentElement.addEventListener("theme:loading:end", () => { let e = document.querySelector(".collection-products.level_two_filters"); e.innerHTML = "", document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l2_subcategory"] input:not([disabled])').forEach(t => { let r = document.createElement("p"); r.textContent = t.value, r.dataset.value = t.value, r.classList.add("all-filters-categories"), r.addEventListener("click", () => { let e = document.querySelector(`[id="facet-filter-filter.p.m.custom.l2_subcategory"] input[type="checkbox"][value="${t.value}"]`); e && (e.click(), e.checked ? r.classList.add("selected-category") : r.classList.remove("selected-category")) }), console.log("4", "checkbox"), e.appendChild(r), o() }), l() }), document.querySelector("product-facet").addEventListener("facet:criteria-changed", e => { document.documentElement.addEventListener("theme:loading:end", e => { if (t) { console.log("55555", "checkbox"); let o = document.querySelector(`input[type="checkbox"][value="${r}"]`); console.log(o, "checkbox checkboxAgain"), o?.click(), t = !1 } }) }) } function l() { document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l2_subcategory"] input[type="checkbox"]:checked').forEach(e => { let t = document.querySelector(`.collection-products.level_two_filters p[data-value="${e.value}"]`); t && t.classList.add("selected-category") }) } function c() { document.querySelectorAll(".collection-products.level_two_filters p.selected-category").forEach(e => e.classList.remove("selected-category")), document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l2_subcategory"] input[type=checkbox]:checked')?.forEach(e => e.click()) } document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l1_category"] input[type=checkbox]').forEach(e => { n.push(e.value) }), [...new Set(n)].forEach(e => { let o = document.createElement("p"); o.textContent = e, o.dataset.value = e, o.classList.add("all-filters-categories"), o.addEventListener("click", () => { document.querySelectorAll("p.selected-category").forEach(e => { e.classList.remove("selected-category"), document.querySelectorAll('[id="facet-filter-filter.p.m.custom.l1_category"] input[type=checkbox]:checked').forEach(e => e.click()) }); let s = document.querySelector(`input[type="checkbox"][value="${e}"]`); s && (!0 === s.disabled && (t = !0, r = e), o.classList.toggle("selected-category"), c(), a(), s.click(), console.log(s, "checkbox"), console.log("1", "checkbox")) }), document.querySelector(".collection-products.level_one_filters").appendChild(o), console.log("2", "checkbox") }), a(); let d = new URLSearchParams(window.location.search), u = d.get("filter.p.m.custom.l1_category"), p = d.get("filter.p.m.custom.l2_subcategory"); if (u) { let m = document.querySelector(`.level_one_filters p[data-value="${u}"]`); if (m) { m.click(); let f = document.querySelector(`input[type="checkbox"][value="${u}"]`); if (f && (f.click(), f.click(), f.click(), p)) { let y = document.querySelector(`.level_two_filters p[data-value="${p}"]`); if (y) { y.click(); let h = document.querySelector(`input[type="checkbox"][value="${p}"]`); h && h.click(), h && h.click() } } } } let g = document.querySelector(".collection-quick-filters-subcategory"), v = document.querySelector(".collection-products.level_two_filters"); function b() { v && 0 === v.children.length ? g.style.display = "none" : g.style.display = "block" } b(), document.documentElement.addEventListener("theme:loading:end", function () { b() }) }), document.documentElement.addEventListener("theme:loading:start", function () { console.log("facet:criteria-changed theme:loading:start"), document.documentElement.querySelector(".collection-quick-filters-subcategory").style.display = "none", document.documentElement.querySelector(".product-facet__quickfilter_container").style.display = "none", document.querySelectorAll(".product-item").forEach(function (e) { e.classList.add("skeleton-loading") }), o() }), document.documentElement.addEventListener("theme:loading:end", function () { console.log("facet:criteria-changed theme:loading:end"), document.documentElement.querySelector(".collection-quick-filters-subcategory").style.display = "block", document.documentElement.querySelector(".product-facet__quickfilter_container").style.display = "flex", document.querySelectorAll(".product-item").forEach(function (e) { e.classList.remove("skeleton-loading") }), o() }), document.documentElement.querySelector("#mobile-facet-toolbar").style.display = "none", document.querySelector(".collection-quick-filters-category-static").addEventListener("click", function () { a({ countType: "A" }) }), document.querySelector(".product-facet__meta-bar-item--Filters_button").addEventListener("click", function () { a({ countType: "B" }) }) } document.querySelector(".shopify-section--main-product")?.addEventListener("change", function (e) { document.querySelector("#variant_id") && (document.querySelector("#variant_id").value = e.currentTarget.querySelector('[name="id"]').value) }), document.documentElement.querySelector(".shopify-section--main-product product-rerender form")?.addEventListener("variant:changed", function (e) { console.log(e.detail.variant.id, "event.detail.variant.id"); let t = document.querySelector('.shopify-section--main-product product-rerender form [name="properties[_variant_id]"]'); t && (t.value = e.detail.variant.id); let r = document.querySelectorAll("[data-img]"); if (r.length) { let o = Array.from(r)?.filter(t => t.dataset.img.includes(e.detail.variant.id)); o.length && o.forEach(t => { t.src = t.dataset.img.split(",")?.find(t => t.includes(e.detail.variant.id)) }) } }), document.documentElement.querySelector("flickity-carousel")?.addEventListener("flickity:slide-changed", e => { 1 != e.detail || e.target.closest(".study-showed") || (e.target.closest(".product__media-list-wrapper").querySelector(".consumer-study")?.classList.add("active"), e.target.closest(".shopify-section--main-product").classList.add("study-showed")), 1 != e.detail && e.target.closest(".product__media-list-wrapper").querySelector(".consumer-study").classList.contains("active") && (e.target.closest(".product__media-list-wrapper").querySelector(".consumer-study")?.classList.remove("active"), e.target.closest(".shopify-section--main-product").classList.add("study-showed")) }); let mainCarousel = document.documentElement.querySelector("flickity-carousel"); mainCarousel?.addEventListener("flickity:ready", e => { mainCarousel = document.documentElement.querySelector("flickity-carousel"), console.log(mainCarousel, "mainCarousel"), mainCarousel.addEventListener("video:played", () => mainCarousel.setDraggable(!0)) }), document.addEventListener("click", function (e) { e.target.classList.contains("clear-browsing") && (localStorage.setItem("theme:recently-viewed-products", ""), document.querySelector("predictive-search-drawer recently-viewed-products").remove()) }); class RecentSearchWidget extends HTMLElement {
    constructor() { super(), this.maxHistory = 5, this.render() } connectedCallback() { this.loadSearchHistory(), this.setupEventListeners() } render() {
        this.innerHTML = `
            <div class="recent-searches" id="recent-container">
                <div class="head">
                  <h3 class="browsing-title">Your Recent Searches</h3>
                  <a class="clear-all">Clear All</a>
                </div>
                <div id="search-list"></div>
            </div>
        `} loadSearchHistory() {
        let e = this.querySelector("#search-list"); e.innerHTML = ""; let t = this.querySelector("#recent-container"), r = JSON.parse(localStorage.getItem("recentSearches")) || []; 0 === r.length ? t.style.display = "none" : r.forEach(t => {
            let r = document.createElement("div"); r.classList.add("recent-item"); let o = "/search?q=" + encodeURIComponent(t.trim()).replaceAll(" ", "+"); r.innerHTML = `
                <a href="${o}"><span>${t}</span></a>
                <button data-search="${t}" class="delete"></button>
            `, e.appendChild(r)
        })
    } setupEventListeners() { document.querySelector(".predictive-search__input").addEventListener("keydown", e => { "Enter" === e.key && e.target.value.trim() && this.saveSearch(e.target.value.trim()) }), document.querySelector(".predictive-search__results").addEventListener("click", e => { let t = e.target.closest(".predictive-search__linklist-link"); console.log(t, "resultItem"), t && this.saveSearch(t.textContent.trim()) }), this.addEventListener("click", e => { e.target.classList.contains("delete") && this.removeSearch(e.target.dataset.search), e.target.classList.contains("clear-all") && this.clearAll() }) } saveSearch(e) { let t = JSON.parse(localStorage.getItem("recentSearches")) || []; (t = t.filter(t => t !== e)).unshift(e), t.length > this.maxHistory && t.pop(), localStorage.setItem("recentSearches", JSON.stringify(t)), this.loadSearchHistory() } removeSearch(e) { let t = JSON.parse(localStorage.getItem("recentSearches")) || []; t = t.filter(t => t !== e), localStorage.setItem("recentSearches", JSON.stringify(t)), this.loadSearchHistory() } clearAll() { localStorage.removeItem("recentSearches"), this.loadSearchHistory() }
} customElements.define("recent-search-widget", RecentSearchWidget), document.querySelector("#predictive-search-form").addEventListener("input", function (e) { "" != e.target.value ? document.querySelector(".search-widgets").classList.add("hide") : document.querySelector(".search-widgets").classList.remove("hide") });

// Update timer design
function startSaleTimer(timerElement, product_page = false) {
  if (!timerElement) return;

  console.log('Starting sale timer for element:', timerElement);

  // Remove inline style and hide-timer class
  timerElement.removeAttribute('style');
  timerElement.classList.remove('hide-timer');
  
  function parseDateTime(dateTimeStr) {
    try {
      const [datePart, timePart] = dateTimeStr.split(' ');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    } catch (e) {
      console.error('Error parsing date and time:', dateTimeStr, e);
      return null;
    }
  }

  // Get dates
  const startDate = parseDateTime(timerElement.dataset.startDate);
  const endDate = parseDateTime(timerElement.dataset.endDate);

  console.log('Parsed start date:', startDate);
  console.log('Parsed end date:', endDate);

  if (!startDate || !endDate) {
    console.error('Invalid dates provided');
    return;
  }

  // Parse update interval
  const updateInterval = parseFloat(timerElement.dataset.updateInterval) || 1;
  const updateIntervalMs = updateInterval * 60 * 60 * 1000; // Convert to milliseconds

  console.log('Update interval (hours):', updateInterval);
  console.log('Update interval (ms):', updateIntervalMs);

  function formatNumber(number) {
    return number < 10 ? '0' + number : number;
  }

  function calculateTimeRemaining() {
    const now = new Date();
    let timeLeft;

    // If current time is before the start date, hide the timer
    if (now < startDate) {
      timerElement.classList.add('hide-timer');
      return;
    }

    // If current time is after the end date, hide the timer
    if (now >= endDate) {
      timerElement.classList.add('hide-timer');
      return;
    }

    // Calculate time since start of sale
    const timeSinceStart = now.getTime() - startDate.getTime();
    
    // Calculate next update time
    const updateCount = Math.floor(timeSinceStart / updateIntervalMs);
    const nextUpdate = new Date(startDate.getTime() + ((updateCount + 1) * updateIntervalMs));

    // We're in the sale period, count down to next update
    timeLeft = nextUpdate.getTime() - now.getTime();

    // Calculate time components
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Only show timer if there's time left
    if (timeLeft > 0) {
      timerElement.classList.remove('hide-timer');
      timerElement.style.setProperty('display', 'flex', 'important');

      timerElement.innerHTML = `
      ${location.href.includes('/product')?`<span class="ligthdeal-txt">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.73533 0.0466165C7.87354 0.126998 7.93807 0.292047 7.89106 0.444853L6.65293 4.46876H8.93751C9.07465 4.46876 9.19867 4.55028 9.25306 4.67617C9.30746 4.80206 9.28182 4.94824 9.18783 5.0481L3.68783 10.8919C3.57825 11.0083 3.40288 11.0338 3.26468 10.9534C3.12648 10.873 3.06194 10.708 3.10896 10.5552L4.34708 6.53126H2.06251C1.92537 6.53126 1.80135 6.44975 1.74695 6.32385C1.69256 6.19796 1.7182 6.05178 1.81219 5.95192L7.31219 0.108167C7.42176 -0.00825506 7.59714 -0.0337645 7.73533 0.0466165ZM2.85809 5.84376H4.81251C4.9216 5.84376 5.02421 5.89554 5.08902 5.98329C5.15383 6.07104 5.17314 6.18434 5.14106 6.2886L4.20113 9.34335L8.14192 5.15626H6.18751C6.07842 5.15626 5.97581 5.10448 5.911 5.01673C5.84619 4.92898 5.82688 4.81568 5.85896 4.71142L6.79888 1.65667L2.85809 5.84376Z" fill="white"></path>
            </svg>
            <span>Lightning Deal</span>
            </span><span class="offer-end-txt">Offer ends in</span>`:''}
        <div style="display: flex; align-items: center; gap: 2px; background: rgba(169, 10, 66, 1); padding: 5px 10px; border-radius: 0 0 8px 8px; width: 100%; justify-content: center;" class="timer-inner">
          <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.73533 0.955674C6.87354 1.03606 6.93807 1.2011 6.89106 1.35391L5.65293 5.37782H7.93751C8.07465 5.37782 8.19867 5.45933 8.25306 5.58523C8.30746 5.71112 8.28182 5.8573 8.18783 5.95716L2.68783 11.8009C2.57825 11.9173 2.40288 11.9428 2.26468 11.8625C2.12648 11.7821 2.06194 11.617 2.10896 11.4642L3.34708 7.44032H1.06251C0.925367 7.44032 0.801348 7.3588 0.746953 7.23291C0.692559 7.10702 0.718198 6.96084 0.812189 6.86097L6.31219 1.01722C6.42176 0.900803 6.59714 0.875293 6.73533 0.955674ZM1.85809 6.75282H3.81251C3.9216 6.75282 4.02421 6.8046 4.08902 6.89235C4.15383 6.98009 4.17314 7.0934 4.14106 7.19766L3.20113 10.2524L7.14192 6.06532H5.18751C5.07842 6.06532 4.97581 6.01354 4.911 5.92579C4.84619 5.83804 4.82688 5.72474 4.85896 5.62048L5.79888 2.56573L1.85809 6.75282Z" fill="white"/>
          </svg>
          <div style="display: flex; justify-content: center; gap: 2px;">
            <div class="timer-section">
              <span class="timer-value" style="font-size: 11px; color: white;">${formatNumber(hours)}h:</span>
            </div>
            <div class="timer-section">
              <span class="timer-value" style="font-size: 11px; color: white;">${formatNumber(minutes)}m:</span>
            </div>
            <div class="timer-section">
              <span class="timer-value" style="font-size: 11px; color: white;">${formatNumber(seconds)}s</span>
            </div>
          </div>
        </div>
      `;
    } else {
      timerElement.classList.add('hide-timer');
    }
  }

  // Update timer every second
  calculateTimeRemaining();
  const timerInterval = setInterval(calculateTimeRemaining, 1000);
  timerElement.dataset.timerId = timerInterval;
}

// Add CSS for timer visibility control
const timerStyles = document.createElement('style');
timerStyles.textContent = `
[data-sale-timer] {
  display: flex !important;
  flex-direction: column;
  align-items: center;
}
  .hide-timer {
    display: none !important;
  }
`;
document.head.appendChild(timerStyles);

// Initialize all sale timers on the page
function initializeSaleTimers() {
  console.log('Clearing existing timers...');
  // Clear any existing timers first
  document.querySelectorAll('[data-sale-timer]').forEach(timer => {
    if (timer.dataset.timerId) {
      clearInterval(parseInt(timer.dataset.timerId));
      console.log(`Cleared timer with ID: ${timer.dataset.timerId}`);
    }
  });

  console.log('Starting new timers...');
  // Start new timers
  document.querySelectorAll('[data-sale-timer]').forEach(timer => {
    console.log('Starting timer for element:', timer);
    startSaleTimer(timer);
  });

  // Initialize timers for product details page
  document.querySelectorAll('.product-item__sale-timer').forEach(timer => {
    console.log('Starting timer for product details element:', timer);
    startSaleTimer(timer, true);
  });
}

// Initialize timers when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeSaleTimers);

// Re-initialize timers when content is updated
document.addEventListener('shopify:section:load', initializeSaleTimers);
document.addEventListener('shopify:block:select', initializeSaleTimers);

// PDP gallery: story-style indicator only for review_listing_images slides
(function () {
  function currentVariantId() {
    var vi = document.querySelector('.shopify-section--main-product input[name="id"]');
    return vi ? String(vi.value) : '';
  }
  function visibleGalleryCells(carousel) {
    var vid = currentVariantId();
    return Array.prototype.slice
      .call(carousel.querySelectorAll('.product__media-item[data-media-type="gallery"]:not(.is-filtered)'))
      .filter(function (el) { return !vid || el.getAttribute('data-gallery-variant-id') === vid; });
  }

  var SEG_TIMER_MS = 5000;

  function rebuild(bar, cells) {
    bar.innerHTML = '';
    for (var i = 0; i < cells.length; i++) {
      var seg = document.createElement('span');
      seg.className = 'product__pgallery-bar__seg';
      var fill = document.createElement('span');
      fill.className = 'product__pgallery-bar__fill';
      seg.appendChild(fill);
      bar.appendChild(seg);
    }
  }

  function clearTimer(carousel) {
    if (carousel.__pgalleryTimer) {
      clearTimeout(carousel.__pgalleryTimer);
      carousel.__pgalleryTimer = null;
    }
  }

  function scheduleAdvance(carousel, idx, total) {
    clearTimer(carousel);
    if (idx >= total - 1) return;
    carousel.__pgalleryTimer = setTimeout(function () {
      var cells = visibleGalleryCells(carousel);
      var nextCell = cells[idx + 1];
      if (nextCell) selectFlickityCell(carousel, nextCell);
    }, SEG_TIMER_MS);
  }

  function resolveActiveIdx(carousel, bar) {
    var cells = visibleGalleryCells(carousel);
    var segs = bar.querySelectorAll('.product__pgallery-bar__seg');
    if (segs.length !== cells.length) {
      rebuild(bar, cells);
      carousel.__pgalleryActiveIdx = -1;
    }
    var activeCell = carousel.querySelector('.product__media-item.is-selected:not(.is-filtered)') || carousel.querySelector('.product__media-item.is-selected');
    if (!activeCell || activeCell.dataset.mediaType !== 'gallery' || activeCell.classList.contains('is-filtered')) {
      return { idx: -1, cells: cells };
    }
    return { idx: cells.indexOf(activeCell), cells: cells };
  }

  // Toggle bar visibility based on whether the active cell is a gallery cell.
  // Does NOT start the progress animation — that's deferred to commitActive()
  // so the 5s countdown only begins after the slide has settled in view.
  function updateVisibility(carousel, bar) {
    var res = resolveActiveIdx(carousel, bar);
    var segs = bar.querySelectorAll('.product__pgallery-bar__seg');
    if (res.idx < 0) {
      bar.style.display = 'none';
      clearTimer(carousel);
      carousel.__pgalleryActiveIdx = -1;
      for (var j = 0; j < segs.length; j++) {
        segs[j].classList.remove('is-active', 'is-done');
      }
      return;
    }
    bar.style.display = 'flex';
  }

  // Activate the segment animation + schedule auto-advance for the
  // currently selected gallery cell. Call only when the slide is settled.
  function commitActive(carousel, bar) {
    var res = resolveActiveIdx(carousel, bar);
    if (res.idx < 0) return;
    if (carousel.__pgalleryActiveIdx === res.idx) return;
    carousel.__pgalleryActiveIdx = res.idx;
    var segs = bar.querySelectorAll('.product__pgallery-bar__seg');
    for (var i = 0; i < segs.length; i++) {
      segs[i].classList.remove('is-active', 'is-done');
      if (i < res.idx) segs[i].classList.add('is-done');
    }
    void bar.offsetWidth; // restart animation
    if (segs[res.idx]) segs[res.idx].classList.add('is-active');
    scheduleAdvance(carousel, res.idx, res.cells.length);
  }

  function selectFlickityCell(carousel, target) {
    var p = carousel.flickityInstance;
    var apply = function (flkty) {
      if (!flkty || !flkty.cells) return;
      for (var i = 0; i < flkty.cells.length; i++) {
        if (flkty.cells[i].element === target) {
          flkty.select(i);
          break;
        }
      }
    };
    if (p && typeof p.then === 'function') {
      p.then(apply);
    } else {
      apply(window.Flickity && window.Flickity.data && window.Flickity.data(carousel));
    }
  }

  function setupGalleryTap(carousel) {
    if (carousel.__pgalleryTapInited) return;
    carousel.__pgalleryTapInited = true;
    carousel.addEventListener('click', function (e) {
      var cell = e.target.closest && e.target.closest('.product__media-item[data-media-type="gallery"]');
      if (!cell || !cell.classList.contains('is-selected')) return;
      var galleryCells = visibleGalleryCells(carousel);
      var idx = galleryCells.indexOf(cell);
      if (idx < 0) return;
      var rect = cell.getBoundingClientRect();
      var goPrev = (e.clientX - rect.left) < rect.width / 2;
      e.preventDefault();
      e.stopPropagation();
      // Tap on right of LAST review image → exit gallery to first listing image.
      if (!goPrev && idx === galleryCells.length - 1) {
        if (typeof Moengage !== 'undefined') {
          var pidInput = document.querySelector('.shopify-section--main-product input[name="product-id"]');
          var vidInput = document.querySelector('.shopify-section--main-product input[name="id"]');
          Moengage.track_event('review_gallery_exit_to_listing', {
            product_id: pidInput ? pidInput.value : null,
            variant_id: vidInput ? vidInput.value : null,
            page_url: window.location.href
          });
        }
        var instP = carousel.flickityInstance || carousel.flickity;
        if (instP && typeof instP.then === 'function') {
          instP.then(function (f) {
            var initIdx = 0;
            for (var i = 0; i < f.cells.length; i++) {
              if (f.cells[i].element.classList.contains('is-initial-selected')) {
                initIdx = i;
                break;
              }
            }
            f.select(initIdx, false, true);
          });
        }
        var thumb = document.querySelector('.pdp-review-thumb');
        if (thumb) {
          thumb.classList.remove('pdp-review-thumb--back');
          setTimeout(function () {
            thumb.classList.remove('pdp-review-thumb--hidden');
          }, 0);
        }
        return;
      }
      if (goPrev && idx === 0) return;
      var targetIdx = goPrev ? idx - 1 : idx + 1;
      selectFlickityCell(carousel, galleryCells[targetIdx]);
    }, true);
  }

  function initBar(carousel) {
    if (carousel.__pgalleryBarInited) return;
    carousel.__pgalleryBarInited = true;
    var wrapper = carousel.parentElement;
    if (!wrapper) return;
    var bar = wrapper.querySelector('[data-pgallery-bar]');
    if (!bar) return;

    var visibility = function () { updateVisibility(carousel, bar); };
    var settle = function () { updateVisibility(carousel, bar); commitActive(carousel, bar); };
    // Initial render — treat current state as settled.
    settle();

    carousel.addEventListener('flickity:ready', settle);
    // Activate the new segment immediately on slide change so taps update the
    // progress bar without waiting for the slide to settle (or the 5s timer).
    carousel.addEventListener('flickity:slide-changed', settle);
    carousel.addEventListener('flickity:slide-settled', settle);

    // Backup: watch for is-selected class changes, in case Flickity events
    // fired before our listeners attached. Only sync visibility — never
    // start the animation here (that would race the slide transition).
    if (window.MutationObserver) {
      var mo = new MutationObserver(visibility);
      mo.observe(carousel, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    setupGalleryTap(carousel);
  }

  function initAll() {
    var carousels = document.querySelectorAll('.product__media-list--pgallery');
    for (var i = 0; i < carousels.length; i++) initBar(carousels[i]);
  }

  function deferredInit() {
    initAll();
    // Flickity init happens async; retry briefly to catch instance attach
    setTimeout(initAll, 300);
    setTimeout(initAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInit);
  } else {
    deferredInit();
  }
  document.addEventListener('shopify:section:load', deferredInit);
})();

$(document).on('click', '.js-estimated-total-toggle', function () {
  var expanded = $(this).attr('aria-expanded') === 'true';
  $(this).attr('aria-expanded', !expanded);
  $('#' + this.getAttribute('aria-controls')).toggleClass('is-expanded', !expanded);
});

// close the price summary when the user clicks anywhere outside the footer
// it lives in (the toggle button itself is inside .mini-cart__drawer-footer
// too, so its own click is a no-op here and still handled by the listener above)
$(document).on('click', function (e) {
  var summary = document.getElementById('mini-cart-price-summary');
  if (!summary || !summary.classList.contains('is-expanded')) return;
  if (e.target.closest('.mini-cart__drawer-footer')) return;
  summary.classList.remove('is-expanded');
  var toggle = document.querySelector('.js-estimated-total-toggle');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
});

// cart-drawer#mini-cart just toggles its `open` attribute (its inner DOM
// persists across close/reopen), so the price-summary toggle state has to be
// reset by hand on close instead of relying on a fresh render.
new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName !== 'open' || mutation.target.id !== 'mini-cart') return;
    if (mutation.target.hasAttribute('open')) return;
    var summary = document.getElementById('mini-cart-price-summary');
    var toggle = document.querySelector('.js-estimated-total-toggle');
    if (summary) summary.classList.remove('is-expanded');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });
}).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });

// TabsNav only toggles the single element named by the clicked button's
// aria-controls, so per-tab "View All" links in .see-all-container (which
// aren't that element) never update on their own - sync them here instead.
document.addEventListener('tabs-nav:changed', function (e) {
  var section = e.target.closest(
    '.shopify-section--featured-collections-new'
  );

  // Ignore events from other sections
  if (!section) return;

  var header = e.target.closest('.section__header');
  var seeAll = header && header.querySelector('.see-all-container');
  if (!seeAll) return;
  var targetId = e.detail.button.getAttribute('aria-controls');
  var matched = false;
  // first-match-only: if two tabs ever end up with the same data-tab-target
  // (e.g. duplicate/blank collection refs), only unhide one of them.
  seeAll.querySelectorAll('[data-tab-target]').forEach(function (el) {
    var isMatch = !matched && el.getAttribute('data-tab-target') === targetId;
    el.hidden = !isMatch;
    if (isMatch) matched = true;
  });
});

// saloni-cart-rate-limit
// Cart rate-limit (429) guard, kept separate from the 422 handler above.
// Cloudflare returns an HTML challenge page (not JSON) when it rate-limits
// cart requests, which used to surface as a raw "Unexpected token" parse
// error. On the first 429 from a /cart endpoint this shows a countdown
// notice and reloads the page; every /cart request after that is blocked
// before it ever reaches the network, so nothing else happens until reload.
(function () {
  var baseFetch = window.fetch;
  if (typeof baseFetch !== 'function') return;

  var rateLimited = false;

  function isCartUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart') !== -1;
  }

  function requestUrl(args) {
    var input = args[0];
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function showCartRateLimitNotice() {
    if (rateLimited) return;
    rateLimited = true;

    var totalMs = 3000;
    var startedAt = Date.now();
    var heading = document.querySelector('cart-drawer .cart-notification .cart-notification__heading');
    var notification = document.querySelector('cart-drawer .cart-notification');
    var errorBox = document.querySelector('.cart-notification-error');
    var errorText = errorBox && errorBox.querySelector('.cart-notification-error-text');

    function render(secondsLeft) {
      var message = "Too many requests. Reloading in " + secondsLeft + "s. Please complete the quick security check to continue.";
      if (heading) heading.textContent = message;
      if (notification) notification.hidden = false;
      if (errorBox) errorBox.style.display = 'flex';
      if (errorText) errorText.textContent = message;
    }

    render(5);
    var timer = setInterval(function () {
      var secondsLeft = Math.ceil((totalMs - (Date.now() - startedAt)) / 1000);
      if (secondsLeft <= 0) {
        clearInterval(timer);
        window.location.reload();
        return;
      }
      render(secondsLeft);
    }, 300);
  }

  window.fetch = function () {
    var args = arguments;
    var url = requestUrl(args);

    if (rateLimited && isCartUrl(url)) {
      return new Promise(function () {}); // page is reloading shortly; let it hang instead of firing more requests
    }

    return baseFetch.apply(this, args).then(function (res) {
      if (res.status === 429 && isCartUrl(res.url)) {
        showCartRateLimitNotice();
        // Never resolve: if the caller sees a response (even a synthetic
        // "failed" one) it runs its own error-display code on the same
        // notification element, fighting our countdown and causing it to
        // flicker. Letting the promise hang is safe — the page reloads
        // in a few seconds anyway.
        return new Promise(function () {});
      }
      return res;
    });
  };
})();
// saloni-cart-rate-limit

// saloni-searchtap-dark-theme-class-leak
// SearchTap navigates to /search via pushState/replaceState instead of a full
// page load whenever the typed query isn't an exact autocomplete suggestion
// match (confirmed by SearchTap as by-design). Because there's no reload, the
// server-rendered "index"/"index-dark" body classes (used for the homepage
// dark theme) never get removed, so the dark-theme CSS keeps applying on top
// of the search results page (header, footer, cart popup, etc). This watches
// for navigation to /search and strips those classes client-side, restoring
// them if the user is ever soft-navigated back off /search.
(function () {
  var THEME_CLASSES = ['index', 'index-dark'];
  var STASH_ATTR = 'data-st-theme-classes-stashed';
  var SEARCH_UI_CLASSES = ['searchtap-search', 'searchtap'];

  function isSearchPath(pathname) {
    return pathname.indexOf('/search') === 0;
  }

  function syncThemeClasses() {
    var body = document.body;
    if (!body) return;

    if (isSearchPath(window.location.pathname)) {
      if (!body.hasAttribute(STASH_ATTR)) {
        var present = THEME_CLASSES.filter(function (cls) {
          return body.classList.contains(cls);
        });
        if (present.length) {
          body.setAttribute(STASH_ATTR, present.join(' '));
          present.forEach(function (cls) {
            body.classList.remove(cls);
          });
        }
      }
    } else if (body.hasAttribute(STASH_ATTR)) {
      body.getAttribute(STASH_ATTR).split(' ').filter(Boolean).forEach(function (cls) {
        body.classList.add(cls);
      });
      body.removeAttribute(STASH_ATTR);
    }
  }

  // Only on genuine browser back/forward (popstate) — not on SearchTap's own
  // pushState/replaceState calls, which also drive its in-modal switching
  // between search and collection-filter views and must be left alone.
  function closeStaleSearchUi() {
    var body = document.body;
    if (!body || isSearchPath(window.location.pathname)) return;
    body.classList.remove.apply(body.classList, SEARCH_UI_CLASSES);
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    history[method] = function () {
      var result = original.apply(this, arguments);
      syncThemeClasses();
      return result;
    };
  });

  window.addEventListener('popstate', function () {
    syncThemeClasses();
    closeStaleSearchUi();
  });
  syncThemeClasses();
})();
// saloni-searchtap-dark-theme-class-leak

/* kavita-cart-analytics */
function isShopifyAnalyticsReady() {
  return typeof Shopify !== "undefined" && !!Shopify.analytics && typeof Shopify.analytics.publish === "function";
}

(() => {
  function publishCartClickEvent(detail) {
    if (!isShopifyAnalyticsReady()) return;
    Shopify.analytics.publish("custom_view_cart_click", detail);
  }

  function getCartItemCount(scope) {
    const badge = (scope && scope.querySelector("cart-count, .cart-count")) || document.querySelector("cart-count");
    return parseInt(badge?.textContent, 10) || 0;
  }

  document.addEventListener("click", (e) => {
    const headerCartIcon = e.target.closest('a[aria-controls="mini-cart"]');
    if (headerCartIcon && e.isTrusted) {
      publishCartClickEvent({
        cart_item_count: getCartItemCount(headerCartIcon),
        click_section: "header",
        click_subsection: "cart_icon",
      });
      return;
    }

    const footerCartIcon = e.target.closest(".footer__sticky-cart");
    if (footerCartIcon) {
      publishCartClickEvent({
        cart_item_count: getCartItemCount(),
        click_section: "footer",
        click_subsection: "cart_icon",
      });
      return;
    }

    const viewCartBtn = e.target.closest(".view-cart-btn");
    if (viewCartBtn) {
      publishCartClickEvent({
        cart_item_count: getCartItemCount(viewCartBtn),
        click_section: viewCartBtn.closest("#cartPopup") ? "cart_popup" : "pdp_sticky_bar",
        click_subsection: "view_cart_button",
      });
    }
  }, true);
})();

(() => {
  const cartDrawer = document.querySelector("cart-drawer#mini-cart");
  if (!cartDrawer) return;

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "open" && isShopifyAnalyticsReady()) {
        Shopify.analytics.publish("cart_drawer_state", { open: cartDrawer.hasAttribute("open") });
      }
    }
  }).observe(cartDrawer, { attributes: true });
})();

(() => {
  const cartDrawer = document.querySelector("cart-drawer#mini-cart");
  if (!cartDrawer) return;

  const CART_SECTIONS = [
    ["cart-drawer-recommendations", "cart_recommendations"],
    ["steal-deal-products", "steal_deal"],
    [".uv-nudge", "uv_nudge"],
    [".cart-discount-main", "discount_block"],
    [".cart-product-recommendations", "ootd_recommendations"],
  ];

  document.addEventListener("click", (e) => {
    if (!cartDrawer.contains(e.target) || !isShopifyAnalyticsReady()) return;

    let section = "cart_drawer_other";
    for (const [selector, label] of CART_SECTIONS) {
      if (e.target.closest(selector)) {
        section = label;
        break;
      }
    }

    Shopify.analytics.publish("cart_add_section", { section, from_cart_drawer: true });
  }, true);
})();

(() => {
  // There can be more than one matching element on the page at once (e.g. a
  // cart-notification in both header.liquid and mini-cart.liquid reacting to the
  // same underlying error), and closing a bottom sheet / variant selector can
  // re-trigger the same validation (e.g. the order-limiter re-checking on close),
  // re-showing the identical message while it was never actually dismissed.
  // Rather than guess a time window, track whether an error is CURRENTLY visible:
  // suppress repeats of the same key while still active, and only allow it to
  // fire again once something has actually gone back to hidden. That collapses
  // true duplicates with no limit on how long they're displayed, while still
  // counting a genuinely new occurrence after a real dismissal, however soon.
  let activeErrorKey = null;

  function publishCartError(detail) {
    if (!isShopifyAnalyticsReady()) return;

    const key = detail.error_type + "|" + detail.error_message;
    if (key === activeErrorKey) return;
    activeErrorKey = key;

    const cartDrawer = document.querySelector("cart-drawer#mini-cart");
    let pageLocation = window.location.href;
    if (cartDrawer && cartDrawer.hasAttribute("open")) {
      pageLocation += "#cart-drawer";
    }

    Shopify.analytics.publish("cart_error_shown", Object.assign({ page_location: pageLocation }, detail));
  }

  function clearActiveError() {
    activeErrorKey = null;
  }

  // Tracks which pre-listed coupon card (discount-block.liquid) was last clicked, since
  // those "Apply" buttons carry a fixed code rather than reading from a text input.
  let lastDiscountCardCode = null;
  document.addEventListener("click", (e) => {
    const card = e.target.closest(".discount-card");
    if (card) {
      lastDiscountCardCode = card.querySelector(".d-title")?.dataset.dtitle || null;
    }
  }, true);

  function getAttemptedDiscountCode() {
    const manualInput = document.getElementById("discount-input");
    if (manualInput && manualInput.value.trim()) return manualInput.value.trim();
    return lastDiscountCardCode;
  }

  // Watches document.body (not individual elements) so error containers re-rendered
  // by Shopify's Section Rendering API (e.g. the cart drawer reloading) stay covered.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const target = mutation.target;
      if (!(target instanceof Element)) continue;

      if (target.matches("cart-notification[global]")) {
        if (!target.hidden && target.classList.contains("cart-notification--error")) {
          const message = target.querySelector(".cart-notification__heading")?.textContent?.trim() || "";
          publishCartError({ error_type: "cart_notification", error_message: message });
        } else if (target.hidden) {
          clearActiveError();
        }
      } else if (target.matches(".discount_error_container")) {
        if (!target.hasAttribute("hidden")) {
          const message = target.querySelector(".err_txt")?.textContent?.trim() || "";
          publishCartError({ error_type: "discount_error", error_message: message, discount_code: getAttemptedDiscountCode() });
        } else {
          clearActiveError();
        }
      }
    }
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ["hidden", "class"] });
})();

(() => {
  // Timestamps the moment ANY add-to-cart request goes out (PDP form, quick-add cards,
  // cart-drawer recommendations, steal-deal, milestone freebie, etc.) by patching fetch
  // rather than listening for clicks on specific buttons, so every add path is covered
  // without needing to track down each widget's markup. The pixel reads this via
  // add_to_cart_request_started and matches it against product_added_to_cart to compute
  // click-to-added latency.
  /* kavita-cart-add-section-outside-drawer */
  // cart_add_section is only published for clicks inside the cart drawer, so adds from
  // the homepage / PDP / collection pages had no section attached. Remember the last
  // click and, for adds that did not originate in the drawer, publish the section the
  // click happened in right before the request goes out.
  let lastClickTarget = null;
  document.addEventListener("click", (e) => { lastClickTarget = e.target; }, true);

  function publishOutsideDrawerAddSection() {
    const cartDrawer = document.querySelector("cart-drawer#mini-cart");
    if (lastClickTarget instanceof Element && cartDrawer && cartDrawer.contains(lastClickTarget)) return;

    // Prefer the readable data-section attribute (e.g. "monsoon-essentials"); fall back to the
    // Shopify section id, which looks like "shopify-section-template--123__custom_featured_collections_AbC".
    const clicked = lastClickTarget instanceof Element ? lastClickTarget : null;
    const dataSection = clicked && clicked.closest("[data-section]");
    const sectionEl = clicked && clicked.closest('[id^="shopify-section-"]');
    const sectionName =
      (dataSection && dataSection.getAttribute("data-section")) ||
      (clicked && clicked.closest(".atc-banner-carousel") && "atc-banner-carousel") ||
      (sectionEl &&sectionEl.id.replace(/^shopify-section-/, "").replace(/^.*__/, "")) ||
      "unknown";
    // Sections with filter tabs (e.g. "Save with Sets": Bestsellers / Skin Care / Hair Care) render
    // each tab's products in a product-list panel that its tab button points at via aria-controls.
    // Append that tab's label so the value reads "<section>-<tab>", e.g. "save-with-sets-skin-care".
    let subsection = "";
    const panel = clicked && clicked.closest('product-list[id^="block-"]');
    if (panel) {
      const tabBtn = document.querySelector('.tabs-nav__item[aria-controls="' + panel.id + '"]');
      subsection = ((tabBtn && tabBtn.textContent) || "")
        .trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    }
    const sectionWithTab = subsection ? sectionName + "-" + subsection : sectionName;
    const pageType = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType) || "";

    // from_cart_drawer is decided here, at request time. The pixel's own isCartDrawerOpen flag
    // is read when Shopify's product_added_to_cart arrives, by which point a bottom-sheet add
    // has already opened the mini-cart, so it wrongly reported those adds as coming from the cart.
    Shopify.analytics.publish("cart_add_section", { section: sectionWithTab, page_type: pageType, from_cart_drawer: false });
  }
  /* end-kavita-cart-add-section-outside-drawer */

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === "string" ? input : input?.url || "";
      const method = ((init && init.method) || (typeof input === "object" && input.method) || "GET").toUpperCase();
      if (method === "POST" && /\/cart\/add(\.js)?(\?|$)/.test(url) && isShopifyAnalyticsReady()) {
        publishOutsideDrawerAddSection();
        Shopify.analytics.publish("add_to_cart_request_started", { started_at: Date.now() });
      } else if (method === "POST" && /\/cart\/change(\.js)?(\?|$)/.test(url) && isShopifyAnalyticsReady()) {
        // kavita-cart-add-section-outside-drawer: the "+" on a product-card quantity stepper
        // (quantity-selector.js) raises an existing line via /cart/change.js, which Shopify
        // still reports as product_added_to_cart. Removals (quantity 0) are not adds.
        let qty = null;
        try { qty = typeof init?.body === "string" ? JSON.parse(init.body).quantity : null; } catch (e) {}
        if (qty !== 0) {
          publishOutsideDrawerAddSection();
          // Also stamp the start time so click-to-added latency works for stepper "+" presses.
          // A stray value from a decrease is harmless: every add overwrites it before it's used.
          Shopify.analytics.publish("add_to_cart_request_started", { started_at: Date.now() });
        }
      }
    } catch (e) {}
    return originalFetch.apply(this, arguments);
  };
})();

(() => {
  // Capture how long THIS page took to load, on every page view. loadEventEnd isn't
  // final until after the 'load' event finishes dispatching, so read it on a tick delay.
  // Published as its own event (not merged into page_view) because page_view fires
  // before the page has finished loading, so the timing isn't known yet at that point.
  // Published on every page load; the pixel keeps only the sampled sessions.
  window.addEventListener("load", () => {
    setTimeout(() => {
      try {
        const nav = performance.getEntriesByType("navigation")[0];
        const loadTimeMs = nav
          ? Math.round(nav.loadEventEnd - nav.startTime)
          : Math.round(performance.timing.loadEventEnd - performance.timing.navigationStart);

        if (isShopifyAnalyticsReady()) {
          Shopify.analytics.publish("pg_page_load_time", {
            load_time_ms: loadTimeMs,
            page_location: window.location.href,
          });
        }
      } catch (e) {}
    }, 0);
  });
})();
/* end-kavita-cart-analytics */
